import { render } from "./ManageChatMessagesPage.vue?vue&type=template&id=528f2cf9&scoped=true"
import script from "./ManageChatMessagesPage.vue?vue&type=script&lang=js"
export * from "./ManageChatMessagesPage.vue?vue&type=script&lang=js"

import "./ManageChatMessagesPage.vue?vue&type=style&index=0&id=528f2cf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528f2cf9"]])

export default __exports__